<template>
  <div style="margin-bottom: 10px; text-align: left">
    <el-button type="primary" @click="createTemplate">新增</el-button>

    <configDialog ref="configDialog" :printBusinessType="printBusinessType" @overEmit="$emit('overEmit')"></configDialog>
  </div>
</template>

<script>
import configDialog from './configDialog.vue';
export default {
  name: "InterBtnBox",
  data() {
    return {
    };
  },
  components:{
    configDialog
  },
  props: {
    printBusinessType: {
      type: Number,
      default: () => { return 0 }
    }
  },
  computed: {
  },
  mounted() {
  },
  methods: {
    createTemplate(){
      this.$refs.configDialog.open()
    }
  },
};
</script>

<style scoped></style>
